import React from 'react'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { IOperationsTabConfig } from '../../types'
import CatalogView, { CATALOG_ASSET_ID, CATALOG_DISPLAY_NAME } from './CatalogView'

/**
 * The Catalog (Products) tab: the Catalog page embedded as the panel. No metric line yet.
 *
 * Shown only where the Catalog tool resolves to a URL for this domain and platform (registered
 * for beta), so users elsewhere never see a tab that opens a blank panel.
 */
export const catalogTab: IOperationsTabConfig = {
    id: 'catalog',
    labelStringId: 'jsma-web-operations-catalogTabLabel',
    renderContent: () => <CatalogView />,
    // Keep the iframe mounted across tab switches so it is not reloaded.
    keepMounted: true,
    isAvailable: () => !!getToolUrl(CATALOG_DISPLAY_NAME, CATALOG_ASSET_ID),
}
